import { INotification } from '@components/common/WapperNotification';
import UtilOrder from '@pages/OrganizedSales/CreateOrders/utilOrder';
import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
  PayloadAction,
  Update
} from '@reduxjs/toolkit';
import OrderManagerApi from 'apis/api/OrderManager';
import Helpers from 'helpers/Helpers';
import { ICustomer } from 'models/Customer';
import { IOrderManager } from 'models/OrderManager';
import { IProductCategory } from 'models/StockManage/CateProductManage';

export const getDetailOfOrder = createAsyncThunk(
  'select/getDetailOfOrder',
  (query: { maDonHang: string; typeOrder: number; forceOpen?: boolean }) => {
    return OrderManagerApi.GetDetailOfOrder(query.maDonHang, query.typeOrder).then(response => {
      const reqData = { ...response.data, forceOpen: query.forceOpen };
      return reqData;
    });
  }
);
export function sortByTimeUpdate(a: IOrderManager, b: IOrderManager): number {
  return new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime();
}

const allOrderAdapter = createEntityAdapter<IOrderManager>({
  selectId: order => order?.maDonHang,
  sortComparer: sortByTimeUpdate
});

export function sortByTimeUpdateCustomer(a: ICustomer, b: ICustomer): number {
  return new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime();
}

const allCustomerAdapter = createEntityAdapter<ICustomer>({
  selectId: customer => customer.maKhachHang,
  sortComparer: sortByTimeUpdateCustomer
});
type ICountOrders = {
  UnSuccesCount?: number;
  ConfirmWaitCount?: number;
  InProcessCount?: number;
  InHoldCount?: number;
  SuccessCount?: number;
  CancelCount?: number;
  AllCount?: number;
};

type initialStateType = {
  countOrders: ICountOrders;
  orderData: Array<IOrderManager>;
  dataTableListOrder: Array<IProductCategory>;
  listProductSelectFixed: Array<IProductCategory>;
  customerSelect?: ICustomer;
  orderSelect?: IOrderManager | null;
  orderCreateBase?: IOrderManager | null;
  orderCreateByJson?: any | null;
  requestReGetOrder?: boolean | null;
  requestReGetCustomer?: boolean | null;
  draftOrders?: IOrderManager[];
  createOrders?: IOrderManager[] | any;
  allOrderData?: EntityState<IOrderManager>;
  allCustomerData?: EntityState<ICustomer>;
  detailBase?: any[];
  detailErrors?: any[];
  detailThuNos?: any[];
  detailChenhLechs?: any[];
  detailDLLG?: any[];
  detailTraHang?: any[];
  detailUpgrades?: any[];
  // productUpgrades?: any[];
  detailPayFees?: any[];
  detailReplace?: any[];
  // liên quan đến các thao tác thuật tiện cho đơn hàng
  listNotification?: Array<INotification>; // ds các thông báo đã nhận
  listHistoryNotis?: Array<INotification>; // ds lịch sử các thông báo chuyển từ đã nhận sang lưu lại khi cần dò thông báo cũ
  notification?: INotification | null;
  openHistoryNoti?: boolean;
  isACNotify?: boolean;
  openQActionOrder?: boolean;
  openUpdateOrder?: boolean;
  openCreateOrderModal?: boolean;
  openCodeJsonModal?: boolean;
  openCodeDraftModal?: boolean;
  openCodeCreateModal?: boolean;
  payedMoney?: number;
  payWillMoney?: number;
  payMethod?: string;
  vatValueMoney?: number;
  otherCost?: number;
  // ariseCost?: number;
  timePostPone?: Date | null;
  requestExportXls?: string | null;
  reqResetCreateForm?: boolean;
  listSameCus?: any[]; // các kh trùng nhau trong ds đơn
  codeProductQuick?: string | null;
  donTaoLai?: any | null;
  taoCongThuNo?: any | null;
  omConfig?: any[];

  // yêu cầu edit đơn nếu đơn đã hoàn tất
  isReqEditOrder?: boolean;
};

const initialState: initialStateType = {
  countOrders: {
    UnSuccesCount: 0,
    ConfirmWaitCount: 0,
    InProcessCount: 0,
    InHoldCount: 0,
    SuccessCount: 0,
    CancelCount: 0,
    AllCount: 0
  },
  orderData: [],
  dataTableListOrder: [], // k còn dùng nữa chuyển qua lưu zustand rồi
  listProductSelectFixed: [], // k còn dùng nữa chuyển qua lưu zustand rồi
  customerSelect: undefined,
  orderSelect: null, // lưu đơn đang cần edit
  orderCreateBase: null, // đơn lấy dữ liệu khách hàng để đưa vào đơn mới tạo nhanh... sẽ phát triển thêm...
  requestReGetOrder: null, // bắt buộc là null để đúng với logic xử lý state của use query
  requestReGetCustomer: null, // bắt buộc là null để đúng với logic xử lý state của use query
  allOrderData: allOrderAdapter.getInitialState(),
  allCustomerData: allCustomerAdapter.getInitialState(),
  detailBase: [],
  detailErrors: [],
  detailThuNos: [],
  detailChenhLechs: [],
  detailDLLG: [],
  detailTraHang: [],
  detailUpgrades: [],
  // productUpgrades: [],
  detailPayFees: [],
  detailReplace: [],
  listNotification: [],
  listHistoryNotis: [],
  notification: null,
  isACNotify: true,
  openQActionOrder: false,
  openUpdateOrder: false,
  orderCreateByJson: null,
  openCreateOrderModal: false,
  openCodeJsonModal: false,
  openCodeDraftModal: false,
  openCodeCreateModal: false,
  payedMoney: 0,
  payWillMoney: 0,
  otherCost: 0,
  vatValueMoney: 0,
  // ariseCost: 0,
  requestExportXls: null,
  reqResetCreateForm: false,
  listSameCus: [],
  openHistoryNoti: false,
  timePostPone: null,
  codeProductQuick: null,
  payMethod: null,
  isReqEditOrder: false,
  donTaoLai: null,
  taoCongThuNo: null
};

const orderManagerSlide = createSlice({
  name: 'orderManager',
  initialState: initialState,
  reducers: {
    resetState: state => {
      state.orderData = [];
      state.orderSelect = undefined;
      state.orderCreateBase = undefined;
    },
    reqCalculate: (state, action: PayloadAction<boolean>) => {
      const list: any = allOrderAdapter.getSelectors().selectAll(state.allOrderData);
      const rltCount = UtilOrder.countOrders(list);
      // console.log('rltCount in store', rltCount);
      state.countOrders = rltCount;
    },
    updateCountOrder: (state, action: PayloadAction<ICountOrders>) => {
      state.countOrders = action.payload;
    },
    updateReqReGetOrder: (state, action: PayloadAction<boolean>) => {
      state.requestReGetOrder = action.payload;
    },
    updateReqReGetCustomer: (state, action: PayloadAction<boolean>) => {
      // console.log('updateReqReGetCustomer', action.payload);
      state.requestReGetCustomer = action.payload;
    },
    updateReqExportXls: (state, action: PayloadAction<string | null>) => {
      switch (action.payload) {
        case '1':
          state.requestExportXls = 'tatcadonhang';
          break;
        case 'ConfirmWait':
          state.requestExportXls = 'donchuahoantat';
          break;
        case '3':
          state.requestExportXls = 'donchoxacnhan';
          break;
        case 'InProcess':
          state.requestExportXls = 'dondangthuchien';
          break;
        case 'InHold':
          state.requestExportXls = 'donchotamhoan';
          break;
        case 'Success':
          state.requestExportXls = 'donhoantat';
          break;
        case '2':
          state.requestExportXls = 'donchuahoantat';
          break;
        case '4':
          state.requestExportXls = 'dondangthuchien';
          break;
        case '5':
          state.requestExportXls = 'donchotamhoan';
          break;
        case '6':
          state.requestExportXls = 'donhoantat';
          break;
        default:
          state.requestExportXls = null;
          break;
      }
    },
    resetDataListDataTable: state => {
      state.dataTableListOrder = [];
      state.listProductSelectFixed = [];
    },
    updateDataTableListOrder: (state, action: PayloadAction<Array<IProductCategory>>) => {
      state.dataTableListOrder = action.payload;
    },
    updateListProductSelectFixed: (state, action: PayloadAction<Array<IProductCategory>>) => {
      state.listProductSelectFixed = action.payload;
    },
    updateCustomerSelect: (state, action: PayloadAction<ICustomer | undefined>) => {
      state.customerSelect = action.payload;
    },
    updateAllOrderData: (state, action: PayloadAction<Array<IOrderManager>>) => {
      //  thay cho setAll là dùng để cập nhật thêm (đã có thì update chưa có thì thêm vô) => sẽ rất hiệu quả để cập nhật data
      // tuy nhiên đối với table 2 bước gọi api thì k thể dùng upsert!!, mọi cập nhật đơn đều phải qua action: updateOneOrderData

      if (state.requestReGetOrder === true) {
        allOrderAdapter.setAll(state.allOrderData, action.payload); // k cần xử lý nữa
        state.requestReGetOrder = false; // tắt state update !
      } else {
        allOrderAdapter.setAll(state.allOrderData, action.payload); // k cần xử lý nữa
      }
      if (state.orderSelect) {
        state.orderSelect = allOrderAdapter
          .getSelectors()
          .selectById(state.allOrderData, state.orderSelect!.maDonHang)!;
      }
    },
    updateAllCustomerData: (state, action: PayloadAction<Array<ICustomer>>) => {
      //  thay cho setAll là dùng để cập nhật thêm (đã có thì update chưa có thì thêm vô) => sẽ rất hiệu quả để cập nhật data
      // tuy nhiên đối với table 2 bước gọi api thì k thể dùng upsert!!, mọi cập nhật đơn đều phải qua action: updateOneOrderData
      if (state.requestReGetCustomer === true) {
        allCustomerAdapter.setAll(state.allCustomerData, action.payload); // k cần xử lý nữa
        state.requestReGetCustomer = false; // tắt state update !
      } else {
        allCustomerAdapter.setAll(state.allCustomerData, action.payload); // k cần xử lý nữa
      }
      if (state.customerSelect) {
        state.customerSelect = allCustomerAdapter
          .getSelectors()
          .selectById(state.allCustomerData, state.customerSelect!.maKhachHang)!;
      }
    },
    updateManyOrderData: (state, action: PayloadAction<Array<Update<IOrderManager>>>) => {
      allOrderAdapter.updateMany(state.allOrderData, action.payload);
      // sau đó cập nhật cho xe được chọn để hiện thông tin chi tiết info
      if (state.orderSelect) {
        state.orderSelect = allOrderAdapter
          .getSelectors()
          .selectById(state.allOrderData, state.orderSelect!.maDonHang)!;
      }
      if (state.orderCreateBase) {
        state.orderCreateBase = allOrderAdapter
          .getSelectors()
          .selectById(state.allOrderData, state.orderSelect!.maDonHang)!;
      }
    },
    // chỉ dùng nội bộ trong slice store
    updateOneOrderData: (state, action: PayloadAction<Update<IOrderManager>>) => {
      // VỪA UPDATE VÀO LIST DATA VÀ VỪA CẬP NHẬT VÀO CÁI ĐƠN ĐANG SELECT...
      const dataChange: any = action.payload?.changes;
      dataChange && allOrderAdapter.upsertOne(state.allOrderData, dataChange);
    },
    // dùng ra ngoài
    updateOneOrderOnlyData: (state, action: PayloadAction<Update<IOrderManager>>) => {
      // chỉ update data vào list k tiến hành thao tác thêm gì khác tránh render bla bla..
      const dataChange: any = action.payload?.changes;
      dataChange && allOrderAdapter.upsertOne(state.allOrderData, dataChange);
    },
    addOneOrderInTopList: (state, action: PayloadAction<Array<IOrderManager>>) => {
      const list: any = allOrderAdapter.getSelectors().selectAll(state.allOrderData);
      const newList: any = [...action.payload, ...list];
      allOrderAdapter.setAll(state.allOrderData, newList); // set data mới lên đầu tiên của list cái nào đã có sẽ được gộp lấy cái mới nhất
      state.requestReGetOrder = false; // tắt state update !
    },
    addOneCustomerInTopList: (state, action: PayloadAction<Array<ICustomer>>) => {
      const list: any = allCustomerAdapter.getSelectors().selectAll(state.allCustomerData);
      const newList: any = [...action.payload, ...list];
      // console.log('newList', newList);
      allCustomerAdapter.setAll(state.allCustomerData, newList); // set data mới lên đầu tiên của list cái nào đã có sẽ được gộp lấy cái mới nhất
    },
    pushOrderInTopList: (state, action: PayloadAction<Array<IOrderManager>>) => {
      // lọc ra các đơn chưa có trong list rồi mới upsert

      const listNew: any = [];
      for (let i = 0; i < action.payload.length; i++) {
        let findExist: any = allOrderAdapter
          .getSelectors()
          .selectById(state.allOrderData, action.payload[i]?.maDonHang);
        if (!findExist) {
          // tìm không có thì push vô
          listNew.push(action.payload[i]);
        }
        // tìm có thì coi trạng thái đơn hàng và ưu tiên đơn hay không có khác cũ và mới thì cập nhật lại..
        if (
          findExist &&
          (findExist.isPrioritized != action.payload[i].isPrioritized ||
            findExist.currentStatus != action.payload[i].currentStatus ||
            findExist.operatorSeen != action.payload[i].operatorSeen ||
            findExist.yeuCauChinhSua != action.payload[i].yeuCauChinhSua ||
            findExist.orderType.id != action.payload[i].orderType.id)
        ) {
          findExist = { ...findExist };
          findExist['isPrioritized'] = action.payload[i].isPrioritized;
          findExist['currentStatus'] = action.payload[i].currentStatus;
          findExist['operatorSeen'] = action.payload[i].operatorSeen;
          findExist['yeuCauChinhSua'] = action.payload[i].yeuCauChinhSua;
          findExist['orderType'] = action.payload[i].orderType;

          const rltFormat = findExist.isDetailLoaded
            ? UtilOrder.formatOneDataOrder(findExist)
            : UtilOrder.formatVarOrder(findExist);
          listNew.push(rltFormat);
        }
      }
      // console.log('listNew', listNew);
      listNew.length != 0 && allOrderAdapter.upsertMany(state.allOrderData, listNew);
    },
    updateCreateBaseOrder: (state, action: PayloadAction<string | null>) => {
      if (action.payload === null) {
        state.orderCreateBase = null;
      } else {
        const orderSearch = allOrderAdapter.getSelectors().selectById(state.allOrderData, action.payload)!;
        // tìm device đã chọn theo plate và add nó vào xe chọn
        if (orderSearch) {
          state.orderCreateBase = { ...orderSearch };
        } else {
          state.orderCreateBase = null;
        }
      }
    },
    // set đang đang db click => set trước rồi đổ thêm data
    updateOrderSelected: (state, action: PayloadAction<string | null>) => {
      // state.orderCreateBase = null;
      if (action.payload === null) {
        state.orderSelect = null;
      } else {
        const orderSearch = allOrderAdapter.getSelectors().selectById(state.allOrderData, action.payload)!;
        console.log('selectedRealtimeDeviceTreeview', orderSearch);
        // tìm device đã chọn theo plate và add nó vào xe chọn
        if (orderSearch) {
          state.orderSelect = { ...orderSearch };
        } else {
          // trường hợp tìm k ra thì phải xử lý gọi api theo mã đơn hàng để lấy đơn đó về rồi add vô list đơn và bật select đơn
          //  bắt buộc phải xử lý tách biệt k phụ thuộc trang nào để linh động việc xem chi tiết đơn
          state.orderSelect = null;
        }
      }
    },
    forceUpdateOrderClick: (state, action: PayloadAction<any>) => {
      // state.orderCreateBase = null;
      if (action.payload === null) {
        state.orderSelect = null;
      } else {
        state.orderSelect = { ...action.payload };
        state.orderCreateBase = { ...action.payload };
      }
    },
    updateDetailOrder: (
      state,
      action: PayloadAction<{
        type:
          | 'trahang'
          | 'thuno'
          | 'feetracking'
          | 'base'
          | 'error'
          | 'upgrade'
          | 'payfees'
          | 'replace'
          | 'dlgium'
          | 'chenhlech'
          | null;
        data: any[] | null;
      }>
    ) => {
      if (!action.payload.type) {
        // reset all
        state.detailBase = [];
        state.detailErrors = [];
        state.detailUpgrades = [];
        state.detailThuNos = [];
        state.detailChenhLechs = [];
        // state.productUpgrades = [];
        state.detailPayFees = [];
        state.detailReplace = [];
      }
      if (action.payload.type == 'base') {
        state.detailBase = action.payload.data;
      }
      if (action.payload.type == 'error') {
        state.detailErrors = action.payload.data;
      }
      if (action.payload.type == 'upgrade') {
        state.detailUpgrades = action.payload.data;
        // state.productUpgrades = action.payload.data;
      }

      if (action.payload.type == 'payfees') {
        state.detailPayFees = action.payload.data;
      }
      if (action.payload.type == 'dlgium') {
        state.detailDLLG = action.payload.data;
      }
      if (action.payload.type == 'trahang') {
        state.detailTraHang = action.payload.data;
      }
      if (action.payload.type == 'replace') {
        state.detailReplace = action.payload.data;
      }
      if (action.payload.type == 'thuno') {
        state.detailThuNos = action.payload.data;
      }
      if (action.payload.type == 'chenhlech') {
        state.detailChenhLechs = action.payload.data;
      }
    },
    pushNotifications: (state, action: PayloadAction<any>) => {
      state.notification = action.payload;
    },
    changeACNotify: (state, action: PayloadAction<boolean>) => {
      state.isACNotify = action.payload;
    },
    changeQActionOrder: (state, action: PayloadAction<boolean>) => {
      state.openQActionOrder = action.payload;
    },
    changeOpenUpdateOrder: (state, action: PayloadAction<boolean>) => {
      state.openUpdateOrder = action.payload;
    },
    changeCreateOrderByJson: (state, action: PayloadAction<any>) => {
      state.orderCreateByJson = action.payload;
    },
    updateOpenCreateOrderModal: (state, action: PayloadAction<boolean>) => {
      state.openCreateOrderModal = action.payload;
    },
    updateDonTaoLai: (state, action: PayloadAction<any>) => {
      if (action.payload.type === 'taolaidon') {
        state.donTaoLai = action.payload.data;
      } else if (action.payload.type === 'taocongduno') {
        state.taoCongThuNo = action.payload.data;
      } else {
        state.donTaoLai = action.payload.data;
      }
    },
    updateOpenCodeJsonModal: (state, action: PayloadAction<boolean>) => {
      state.openCodeJsonModal = action.payload;
    },
    updateOpenDraftModal: (state, action: PayloadAction<boolean>) => {
      state.openCodeDraftModal = action.payload;
    },
    updateOpenCreateModal: (state, action: PayloadAction<boolean>) => {
      state.openCodeCreateModal = action.payload;
    },
    addDraftOrders: (state, action: PayloadAction<IOrderManager | any>) => {
      const orderSave: any = {
        ...action.payload,
        isNew: action.payload.maDonHang ? false : true,
        maDonSave: (state.draftOrders?.length || 0) + 1,
        timeSave: Helpers.ConvertDateToISOString(new Date())
      };
      const currentList = state.draftOrders || [];
      if (action.payload) state.draftOrders = [...currentList, orderSave];
    },
    addCreateOrders: (state, action: PayloadAction<IOrderManager | any>) => {
      // console.log('action', action.payload);
      if (action.payload) state.createOrders = action.payload;
    },
    removeDraftOrders: (state, action: PayloadAction<{ maDonHang?: string; clearAll?: boolean }>) => {
      if (action.payload.clearAll) {
        state.draftOrders = [];
        return;
      }
      const checkExist = state.draftOrders.findIndex(
        (draftOrder: IOrderManager) => draftOrder?.maDonSave === action.payload.maDonHang
      );
      state.draftOrders.splice(checkExist, 1);
    },
    addNotification: (state, action: PayloadAction<INotification>) => {
      const checkExist = state.listNotification.findIndex(note => note.maDonHang === action.payload.maDonHang);
      console.log('addNotification 0', checkExist);
      if (checkExist > -1) {
        // cập nhật mới nếu đã tồn tại cái cũ
        state.listNotification[checkExist] = { ...action.payload };
        return;
      }
      const notify = [action['payload']];
      const orderSave: INotification[] = [...state.listNotification, ...notify];
      state.listNotification = orderSave;

      console.log('addNotification 1', notify);
    },
    removeNotification: (state, action: PayloadAction<{ maDonHang?: string; clearAll?: boolean }>) => {
      if (action.payload.clearAll) {
        state.listNotification = [];
        return;
      }
      const checkExist = state.listNotification.findIndex(note => note.maDonHang === action.payload.maDonHang);
      state.listNotification.splice(checkExist, 1);
    },
    updateOpenHistoryNoti: (state, action: PayloadAction<boolean>) => {
      state.openHistoryNoti = !state.openHistoryNoti;
    },
    addHistoryNoti: (state, action: PayloadAction<INotification>) => {
      const checkExist = state.listHistoryNotis.findIndex(note => note.maDonHang === action.payload.maDonHang);
      // console.log('addNotification 0', checkExist);
      if (checkExist > -1) {
        // cập nhật mới nếu đã tồn tại cái cũ
        state.listHistoryNotis[checkExist] = { ...action.payload };
        return;
      }
      const notify = [action['payload']];
      const orderSave: INotification[] = [...state.listHistoryNotis, ...notify];
      state.listHistoryNotis = orderSave;
    },
    removeHistoryNoti: (state, action: PayloadAction<{ maDonHang?: string; clearAll?: boolean }>) => {
      if (action.payload.clearAll) {
        state.listHistoryNotis = [];
        return;
      }
      const checkExist = state.listHistoryNotis.findIndex(note => note.maDonHang === action.payload.maDonHang);
      state.listHistoryNotis.splice(checkExist, 1);
    },
    updatePayMethod: (state, action: PayloadAction<any>) => {
      state.payMethod = action.payload;
    },
    updatePayedMoney: (state, action: PayloadAction<any>) => {
      state.payedMoney = action.payload;
    },
    updatePayWillMoney: (state, action: PayloadAction<any>) => {
      state.payWillMoney = action.payload;
    },
    updateVatValueMoney: (state, action: PayloadAction<any>) => {
      state.vatValueMoney = action.payload;
    },
    // updateAriseCost: (state, action: PayloadAction<any>) => {
    //   state.ariseCost = action.payload;
    // },
    updateOtherCost: (state, action: PayloadAction<any>) => {
      state.otherCost = action.payload;
    },
    updateTimePostPone: (state, action: PayloadAction<any>) => {
      state.timePostPone = action.payload;
    },
    updateSameCustomer: state => {
      const listOrder = allOrderAdapter.getSelectors().selectAll(state?.allOrderData);
      state.listSameCus = Helpers.CalSameCustomer(listOrder.map(order => order?.customerInfo?.maKhachHang));
    },
    updateResetCreateForm: (state, action: PayloadAction<any>) => {
      state.reqResetCreateForm = action.payload;
    },
    updateCodeProductQuick: (state, action: PayloadAction<string>) => {
      state.codeProductQuick = action.payload;
    },
    updateIsReqEditOrder: (state, action: PayloadAction<boolean>) => {
      state.isReqEditOrder = action.payload;
    },
    updateOMConfig: (state, action: PayloadAction<any>) => {
      state.omConfig = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getDetailOfOrder.fulfilled, (state, action) => {
      const rltFormat = UtilOrder.formatOneDataOrder(action.payload?.data);
      // console.log('addCase getDetailOfOrder', action.payload?.data, action.payload?.forceOpen);
      if (!rltFormat) {
        console.log('Lỗi getDetailOfOrder..');
        return;
      }
      const updateValue = {
        id: rltFormat.maDonHang,
        changes: rltFormat
      };

      // chưa có thì thêm vô list vì thường là hợp lệ k trùng cũ
      allOrderAdapter.addOne(state.allOrderData, rltFormat);
      // nếu có đang chọn base thì cho cập nhật cái đang chọn theo base tạm chưa dùng
      if (state.orderCreateBase && rltFormat.maDonHang == state.orderCreateBase.maDonHang) {
        state.orderCreateBase = { ...rltFormat };
      }

      if (!state.orderSelect || action.payload?.forceOpen == true) {
        // chưa có chọn đơn hoặc là buộc update
        state.orderSelect = { ...rltFormat };
      } else if (state.orderSelect && rltFormat.maDonHang === state.orderSelect.maDonHang) {
        // có chọn đơn rồi
        state.orderSelect = { ...rltFormat };
      }
      // khi nào force thì bật modal lên
      if (action.payload?.forceOpen == true) {
        !state.openUpdateOrder && (state.openUpdateOrder = true);
      }

      // cập nhật 1 phần tử trong store
      action.payload = updateValue;
      orderManagerSlide.caseReducers.updateOneOrderData(state, action);
    });
  }
});

export const allOrderSelector = allOrderAdapter.getSelectors((state: any) => state.orderManager.allOrderData);

export const {
  resetState,
  updateDataTableListOrder,
  updateListProductSelectFixed,
  updateCustomerSelect,
  updateCreateBaseOrder,
  resetDataListDataTable,
  updateReqReGetOrder,
  updateReqExportXls,
  updateAllOrderData,
  updateManyOrderData,
  updateOneOrderData,
  updateOneOrderOnlyData,
  addOneOrderInTopList,
  pushOrderInTopList,
  updateOrderSelected,
  forceUpdateOrderClick,
  updateDetailOrder,
  pushNotifications,
  changeACNotify,
  changeQActionOrder,
  changeOpenUpdateOrder,
  addNotification,
  addHistoryNoti,
  updateOpenHistoryNoti,
  changeCreateOrderByJson,
  updateOpenCreateOrderModal,
  updateOpenCodeJsonModal,
  updateOpenDraftModal,
  addDraftOrders,
  removeDraftOrders,
  removeNotification,
  removeHistoryNoti,
  updateCountOrder,
  updatePayMethod,
  updatePayedMoney,
  updatePayWillMoney,
  updateVatValueMoney,
  // updateAriseCost,
  updateOtherCost,
  reqCalculate,
  updateResetCreateForm,
  updateCodeProductQuick,
  updateIsReqEditOrder,
  updateSameCustomer,
  updateTimePostPone,
  //  new
  updateReqReGetCustomer,
  addOneCustomerInTopList,
  updateAllCustomerData,
  updateOpenCreateModal,
  addCreateOrders,
  updateDonTaoLai,
  updateOMConfig
} = orderManagerSlide.actions;

export default orderManagerSlide.reducer;
